<template>
  <el-container>

    <router-view/>
    <div class="footer-divider"></div>
    <el-footer>
      <div> 版权所有© 2025 | 广州市远腾科技有限公司</div>
      <div class="copyright"><a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2024357033号-2</a></div>
  <!--      <p><img src="/assets/image/head-logo.png" width="20"/> <a-->
  <!--        href="https://beian.mps.gov.cn/#/query/webSearch?code=61011302001964" rel="noreferrer" target="_blank">陕公网安备6101130200****号</a>-->
  <!--      </p>-->
    </el-footer>
  </el-container>
</template>

<script>

  export default {
    name: 'App',
    components: {
      // HelloWorld
    },
    created() {

    }
  }
</script>

<style>
  body {
    padding: 0;
    margin: 0;
  }

  .el-container {
    width: 100%;
  }

  .footer-divider {
    margin: 0 auto;
    height: 0.5px;
    width: 75%;
    border-bottom: 0.5px solid #DCDFE6;
  }

  .el-footer {
    position: relative;
    bottom: 0px;
    /*background-color: rgba(239, 239, 239, 0.15);*/
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .el-footer div {
    font-size: 12px;
    margin: 0 10px;
  }

  .copyright a {
    text-decoration: none;
    color: black;
  }

  @media screen and (max-width: 768px) {
    .el-message-box {
      width: 320px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue